import Loadable from "app/components/Loadable";
import { lazy } from "react";

const AgentListPage = Loadable(lazy(() => import("./AgentListPage")));
const AgentFormPage = Loadable(lazy(() => import("./AgentFormPage")));
const AgentConversationsPage = Loadable(lazy(() => import("./AgentConversationsPage")));

const agentRoutes = [
  { path: "agents", element: <AgentListPage /> },
  { path: "agents/custom/:id", element: <AgentFormPage custom /> },
  { path: "agent-conversations", element: <AgentConversationsPage /> },
];

export default agentRoutes;
